import { resolveSiteMetadata } from "../../services/siteMetadata";
import Head from "next/head";
import {ASSET_URL, DEBUG} from "../../config";


export default function Meta({context,title,description,image,video,seo})
{
    ({title, description, image} = resolveSiteMetadata(context, {title, description, image}, seo));
    var finalImage=context.org.logo
    if(image){
        finalImage=image
    }

    if(finalImage && !finalImage.startsWith("http")){
        finalImage=ASSET_URL+finalImage
    }

    var titlePrefix="Charithon.io"
    if(context.org.domain){
        titlePrefix=context.org.domain
    }

    if(DEBUG){
        title="(Dev) "+title
    }

    return(
        <div>
        <Head>
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width,initial-scale=1.0" />

            <title>{(title || "").replace("<!-- -->","")+" | "+titlePrefix}</title>
            <meta name={"description"} content={description} />
            <link rel="icon" href={context.org.logo}/>
            <meta property="og:image" content={finalImage} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            {finalImage && <meta name="twitter:image" content={finalImage} />}

            {video && (
                <meta property="og:video" content={video}/>
            )}

        </Head>

        </div>
    )
}
